import { action } from 'mobx';
import { RoleEditForm } from 'application/role/forms';
import {BaseEditViewStore} from 'core/stores';
import {applicationContext} from 'core/utils';

@applicationContext
class RoleEditViewStore extends BaseEditViewStore {
    constructor(rootStore) {
        const id = rootStore.routerStore.routerState.params.id;

        super(rootStore, {
            name: 'role',
            id: id,
            Form: RoleEditForm,
            authorization: 'coreRoleSection.update',
            actions: () => {
                const service = rootStore.application.baasic.membershipModule.role;
                return {
                    get: async (id, opts) => {
                        const response = await service.get(id, opts);
                        return response.data;
                    },
                    update: async (resource) => {
                        const response = await service.update(resource);
                        return response.data;
                    },
                    create: async (resource) => {
                        const response = await service.create(resource);
                        return response.data;
                    }
                }
            },
            FormClass: RoleEditForm,
        });
    }

    @action.bound
    async onInit({ initialLoad }) {
        if(!initialLoad) {
            this.rootStore.routerStore.goBack();
        }
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.update({
                id: this.id,
                ...resource
            });

            this.form.setFieldsDisabled(false);

            await this.rootStore.routerStore.goBack();
            await setTimeout(() => this.rootStore.notificationStore.success("ROLE.EDIT.SUCCESS"), 10);
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }

    @action.bound
    notifySuccessCreate() {
        this.rootStore.notificationStore.success('ROLE.CREATE.SUCCESS');
    }
}

export default RoleEditViewStore;
